import Promise from 'bluebird';
import { queryString } from 'lib/format';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import { searchApi as SearchAPIConfig } from '../../../config';

const DEFAULT_TIMEOUT = 10000;

const ERROR_PAGE_RESPONSE = {
    page : {
        name: 'Search API Error',
        buckets: []
    }
};
const ENVIRONMENT_CONFIGURATION = {
    dev: {
        serviceUrl: 'http://watch.search.api.dev.espn.com'
    },
    qa: {
        serviceUrl: 'http://watch.search.api.qa.espn.com'
    },
    staging: {
        serviceUrl: 'http://watch.search.api.staging.espn.com'
    },
    prod: {
        serviceUrl: 'http://watch.search.api.espn.com'
    },
    test:
    {
        serviceUrl: 'http://watchsearchelb-1580487457.us-east-1.elb.amazonaws.com'
    }
};

const DEFAULT_CONFIGURATION = {
    serviceUrl : ENVIRONMENT_CONFIGURATION.test.serviceUrl,
    paths: {
        base: '/api/product/v1/watchespn/web/',
        search: '/api/product/v1/watchespn/web/search',
        suggest: '/api/product/v1/watchespn/web/suggest'
    }
};

const config = { ...DEFAULT_CONFIGURATION, ...SearchAPIConfig };

const getServiceUrl = (env = 'test') => {
    if (process.browser) {
        var browserEnvironment = env; //global.watchGlobals && global.watchGlobals.env;
        return ENVIRONMENT_CONFIGURATION[browserEnvironment || env].serviceUrl;
    }
    return ENVIRONMENT_CONFIGURATION[env].serviceUrl;
};

const getPageBaseUrl = (env = 'test') => {
    return `${getServiceUrl(env)}${config.paths.base}`;
};

// Only allow Alpha-numeric or spaces in query
function sanitizeQuery(query) {
    query.q = decodeURIComponent(query.q).replace(/[^a-z0-9\s]/gim, '');
    return query;
}

function getSuggestion(query = {}) {
    const qs = queryString(sanitizeQuery(query));
    const url = `${getServiceUrl(query.env)}${config.paths.suggest}${qs}`;

    if (!Object.keys(query || {}).length) {
        return Promise.reject(new Error('No params to get a suggestion.'));
    }

    return request.get(url)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        }, (err) => {
            if(err.status === 404) {
                return ERROR_PAGE_RESPONSE;
            }
            return fallback.get(url);
        });
}

function getSearchResults(query = {}) {
    const qs = queryString(sanitizeQuery(query));
    const url = `${getServiceUrl(query.env)}${config.paths.search}${qs}`;

    if (!Object.keys(query || {}).length) {
        return Promise.reject(new Error('No params to get a search result.'));
    }

    return request.get(url)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        }, (err) => {
            if(err.status === 404) {
                return ERROR_PAGE_RESPONSE;
            }
            return fallback.get(url);
        });
}

module.exports = {
    getSuggestion,
    getSearchResults
};



// WEBPACK FOOTER //
// ./app/lib/api/SearchAPI.js